import Vue from "vue";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import { getAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";
import { getInfo } from "@/api/login";
import "@/assets/less/animation.css";
import { jumpMixins } from "@/utils/jumpMixins";
export default {
  name: "Home",
  mixins: [mixinDevice, jumpMixins],
  components: {
    Header: Header,
    Banner: Banner,
    Footer: Footer
  },
  data: function data() {
    return {
      bgUrl: "/assets/background.svg",
      courseList5: [],
      courseList6: [],
      tenantConfig: {},
      token: "",
      swiperOptions: {
        speed: 1000,
        // autoHeight: true,
        effect: this._isMobile() ? "fade" : "coverflow",
        //"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        slidesPerView: 2,
        grabCursor: true,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -100,
          depth: 700,
          modifier: 0.5,
          slideShadows: false
        },
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: true
        },
        //开启循环模式
        loop: true
      }
    };
  },
  created: function created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    if (this.tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
    this.getCourseList(5);
    this.getCourseList(6);
  },
  mounted: function mounted() {},
  computed: {
    avatarUrl: function avatarUrl() {
      return this.$store.state.user.info && this.$store.state.user.info.avatar ? "https://cast-files.oss-cn-beijing.aliyuncs.com/" + this.$store.state.user.info.avatar : "/img/avatar.png";
    }
  },
  methods: {
    zhuantiEnter: function zhuantiEnter(i) {
      this.currentZhuantiBg[i] = true;
    },
    zhuantiLeave: function zhuantiLeave(i) {
      this.currentZhuantiBg[i] = false;
    },
    getUserInfo: function getUserInfo() {
      getInfo().then(function (res) {
        console.log(res);
      });
    },
    toDetail: function toDetail(item) {
      var route = this.$router.resolve({
        path: "/course/detail",
        query: {
          id: item.id
        }
      });
      window.open(route.href, "_blank");
    },
    getCourseList: function getCourseList(type) {
      var _this = this;
      getAction("/teaching/teachingCourse/showCourse", {
        column: 'orderNum',
        order: 'desc',
        courseType: type,
        pageSize: 8
      }).then(function (res) {
        if (res.success) {
          switch (type) {
            case 5:
              _this.courseList5 = res.result.records;
              break;
            case 6:
              _this.courseList6 = res.result.records;
              break;
          }
        }
      });
    }
  }
};